<a class="button is-small ml-0 mr-4 mb-4 is-white"
   routerLinkActive="is-active"
   routerLink="/about/the-context">The Context</a>
<a class="button is-small ml-0 mr-4 mb-4 is-white"
   routerLinkActive="is-active"
   routerLink="/about/about-gpai">About GPAI</a>
<a
   class="button is-small ml-0 mr-4 mb-4 is-white"
   routerLinkActive="is-active"
   routerLink="/about/about-oecd-ai">About OECD.AI
</a>
<a
   class="button is-small ml-0 mr-4 mb-4 is-white"
   routerLinkActive="is-active"
   routerLink="/about/network-of-experts">About AIGO</a>
<a class="button is-small ml-0 mr-4 mb-4 is-white"
   routerLinkActive="is-active"
   routerLink="/about/background">Background</a>
<a class="button is-small ml-0 mr-4 mb-4 is-white"
   routerLinkActive="is-active"
   routerLink="/about/partners">Partners</a>

